/* @ts-ignore */
import * as React from 'react';
import { Form, Input, AutoComplete, Select, Upload, Icon, Divider } from 'antd';
import { Button } from '@ui/components';
import { transformFormatSource } from '@ui/tools/transformSource';

import './CreateStoreForm.less';

const { Item } = Form;
let idCity = 0;

export default Form.create({
  name: 'form_in_modal',
  onValuesChange: (props: any, changedValues: any) => {
    if ('city' in changedValues) {
      idCity = Number.parseInt(changedValues.city, 10);
      props.form.setFieldsValue({
        market: '',
      });
      console.log(changedValues.city);
    }
    props.onFieldsChange(changedValues);
  },
})(
  // @ts-ignore
  class extends React.Component {
    render() {
      const {
        // @ts-ignore
        onCreate,
        // @ts-ignore
        form: { getFieldDecorator },
        // @ts-ignore
        cities,
        // @ts-ignore
        factories,
        // @ts-ignore
        markets,
        // @ts-ignore
        collections,
        // @ts-ignore
        file,
        // @ts-ignore
        store: {
          idLotus,
          name,
          city,
          market,
          address,
          phone,
          mail,
          collections: storeCollectionsRaw,
          firstName,
          lastName,
          middleName,
          firstContactPhone,
          secondContactPhone,
          factories: storeFactories,
        },
      } = this.props;

      const storeCollections = (storeCollectionsRaw || []).sort((a: any, b: any) =>
        a.collection.name < b.collection.name ? -1 : 1,
      );

      const dataSource = transformFormatSource(cities);
      const factoriesSource = transformFormatSource(factories).sort((a: any, b: any) => (a.name < b.name ? -1 : 1));
      const marketsSource = transformFormatSource(
        markets.filter((m: any) => m.city?.id === (idCity ? idCity : city.id)),
      );
      const collectionsSource = transformFormatSource(collections).sort((a: any, b: any) => (a.text < b.text ? -1 : 1));

      const handleSelectCollections = (value: string[]) => {
        if (value.includes('all')) {
          return collectionsSource.map((c) => c.value);
        }
        return value;
      };

      return (
        <Form className="create-store-form__form">
          <Item
            label="IdLotus"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {getFieldDecorator('idLotus', { initialValue: idLotus })(<Input size="large" className="input-id-lotus" />)}
          </Item>

          <Item label="Название">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              initialValue: name,
            })(<Input size="large" />)}
          </Item>

          <Item label="Город">
            {getFieldDecorator('city', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              initialValue: city ? city.id.toString() : city,
            })(<AutoComplete dataSource={dataSource} size="large" />)}
          </Item>

          <Item label="ТЦ">
            {getFieldDecorator('market', {
              initialValue: market ? market.id.toString() : '',
            })(
              <Select size="large">
                {marketsSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Item label="Адрес">
            {getFieldDecorator('address', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              initialValue: address,
            })(<Input size="large" />)}
          </Item>

          <Item label="Фабрики">
            {getFieldDecorator('factories', {
              initialValue: storeFactories ? storeFactories.map((item: any) => item.id.toString()) : [],
            })(
              <Select mode="multiple" size="large">
                {factoriesSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Item label="Телефон">
            {getFieldDecorator('phone', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              initialValue: phone,
            })(<Input size="large" />)}
          </Item>

          <Item label="Mail">
            {getFieldDecorator('mail', {
              rules: [{ type: 'email', message: 'Не валидный e-mail' }],
              initialValue: mail,
            })(<Input size="large" />)}
          </Item>

          <Item>
            {getFieldDecorator('file')(
              <Upload beforeUpload={() => false} name={'photo-store'} fileList={file ? [file.file] : []}>
                <div style={{ paddingTop: '16px' }}>
                  <Button type="primary" size="large" className="upload-store-photo">
                    <Icon type="camera" /> загрузить фото
                  </Button>
                </div>
              </Upload>,
            )}
          </Item>

          <Divider orientation="left">
            <span className="create-store-divider">Коллекции</span>
          </Divider>

          <Item label="Эталон">
            {getFieldDecorator('collections', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              initialValue: storeCollections.map((item: any) => item.collection.id.toString()),
              getValueFromEvent: handleSelectCollections,
            })(
              <Select mode="multiple" size="large" onChange={handleSelectCollections}>
                <Select.Option key="all" value="all">
                  Выбрать все
                </Select.Option>
                {collectionsSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Divider orientation="left">
            <span className="create-store-divider">Контактное лицо</span>
          </Divider>

          <Item>
            <Item label="Имя" style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
              {getFieldDecorator('firstName', { initialValue: firstName })(<Input size="large" />)}
            </Item>

            <Item
              label="Отчество"
              style={{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
                marginLeft: '24px',
              }}
            >
              {getFieldDecorator('middleName', { initialValue: middleName })(<Input size="large" />)}
            </Item>
          </Item>

          <Item label="Фамилия">
            {getFieldDecorator('lastName', { initialValue: lastName })(<Input size="large" />)}
          </Item>

          <Item label="Телефон">
            {getFieldDecorator('firstContactPhone', {
              initialValue: firstContactPhone,
            })(<Input size="large" />)}
          </Item>

          <Item style={{ paddingTop: '8px' }}>
            {getFieldDecorator('secondContactPhone', {
              initialValue: secondContactPhone,
            })(<Input size="large" />)}
          </Item>

          <Item style={{ paddingTop: '32px' }}>
            <Button onClick={onCreate} htmlType="submit" className="button-create-store">
              Создать
            </Button>
          </Item>
        </Form>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/scenes/EditStore/components/CreateStoreForm/CreateStoreForm.tsx